<div class="counter">
  <button
    tuiIconButton
    class="counter__button counter__button_left"
    type="button"
    iconStart="@tui.minus"
    [size]="'s'"
    [style.border-radius.%]="100"
    [appearance]="!forceDisabled ? 'primary' : 'grey-button'"
    [disabled]="forceDisabled"
    (click)="changeValue(-1)"
  ></button>

  <div class="counter__label">{{ value | numeralPlurals: labels }}</div>

  <button
    tuiIconButton
    class="counter__button counter__button_right"
    type="button"
    iconStart="@tui.plus"
    [size]="'s'"
    [style.border-radius.%]="100"
    [appearance]="!forceDisabled ? 'primary' : 'grey-button'"
    [disabled]="forceDisabled"
    (click)="changeValue(1)"
  ></button>
</div>
